import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';

// 获取菜单
export const GetExportHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Common/GetExportHistoryPageList", params)
};